// unblock navigation if sidebar clicked and is dirty

import { atom } from 'jotai';

export const isDirtyAtom = atom(false);
